import { cn, IconButton } from "@au-schein-de/au-ui-library";
import type { ComponentProps } from "react";
import { FavoritesLoggedInIconRaw } from "./auth.favorites-logged-in-icon.component";

interface HeaderFavoritesButtonIconProps
	extends Omit<ComponentProps<typeof IconButton>, "icon" | "shape"> {
	showStatusBadge: boolean;
}

export function HeaderFavoritesButtonIcon({
	showStatusBadge,
	className,
	...iconButtonProps
}: HeaderFavoritesButtonIconProps) {
	return (
		<div
			data-testid="storefront-header-favorites-slot"
			className="relative shrink-0"
		>
			<IconButton
				shape="square"
				icon={
					<FavoritesLoggedInIconRaw
						showStatusBadge={showStatusBadge}
						className="text-gray-700"
						data-testid={
							showStatusBadge ? "header-favorites-indicator" : undefined
						}
					/>
				}
				iconSize={{ base: 5, md: 6 }}
				className={cn("!transition-colors !bg-gray-200", className)}
				{...iconButtonProps}
			/>
		</div>
	);
}
